import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

import ProtectedRoute from "./components/authentication//helper/ProtectedRoute";
import UserRoutes from "./components/utils/user/UserRoutes";


import Home from "./components/utils/core/Home";
import SignIn from "./components/authentication/SignIn";
import SignUp from "./components/authentication/SignUp";
import ForgetPassword from "./components/authentication/ForgetPassword";
import ResetPassword from "./components/authentication/ResetPassword";
import UserSettings from "./components/utils/user/UserSettings";
import Admin from "./components/admin/Admin";

// 🔹 New legal pages (update paths to match your structure)
import TermsOfServicePage from "./components/legal/TermsOfServicePage";
import PrivacyPolicyPage from "./components/legal/PrivacyPolicyPage";
import CookiesPolicyPage from "./components/legal/CookiesPolicyPage";
import CancellationRefundPolicyPage from "./components/legal/CancellationRefundPolicyPage"
import DeleteAccountPage from "./components/legal/DeleteAccountPage";
import ContactPage from "./components/legal/ContactPage";

const App = () => {
  return (
    
      <Routes>
        <Route path="/linkedin" element={<LinkedInCallback />} />

        <Route path="/home" element={<Home />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgetPassword/" element={<ForgetPassword />} />
        <Route path="resetPassword/:uid/:id" element={<ResetPassword />} />
        <Route path="/admin" element={<Admin />} />

        {/* 🔹 Public legal routes */}
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
        <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicyPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage/>}/>
        <Route path="/contact" element={<ContactPage />} />


        <Route element={<ProtectedRoute />}>
          <Route path="user/*" element={<UserRoutes />} />
          <Route path="user/settings/*" element={<UserSettings />} />
        </Route>

        <Route path="*" element={<Navigate replace to="/home" />} />
      </Routes>
  
  );
}

export default App;
